import React from 'react';
import { InitSettingType, IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage, FormikHelpers } from 'formik';
import { setFillExampleModalVisibleAction, setSelectVehicleBrandsModalVisibleAction, setSelectVehicleModelsModalVisibleAction } from 'redux/actions/modal.action';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType as InsTypeEnum, InsType } from 'constants/enums/insType.enum';
import service from 'bff/services/carProductService';
import { IVehicleOwnerInfoFormValue } from 'constants/models/components/insureProcessCar/vehicleOwnerInfo';
// import moment from 'moment';
import moment from 'moment-timezone';
import { IVehicleInfoState, IVehicleInfoFormValue } from 'constants/models/components/insureProcessCar/vehicleInfo';
import _ from 'lodash';
import { VehicleBrand, VehicleListContent, VehicleModelListContent, ValidLicenseReq, VehicleCar, VehiclePowerValidationCondition, ValidVehiclePolicyPeriodRes } from 'bff/models/product';
import InputWithRegex from 'components/InputWithRegex';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import FillExampleModal from 'components/InsureProcess/Vehicle/FillExampleModal';
import SelectVehicleBrandsModal from 'components/InsureProcess/Vehicle/SelectVehicleBrandsModal';
import { RootReducersState } from 'redux/reducers';
import { SysOption } from 'bff/models/info';
import { VehiclePowerType } from 'constants/enums/vehiclePowerType.enum';
import { VehiclePowerCode } from 'constants/enums/vehiclePowerCode.enum';
import { DatePicker } from 'formik-antd';
import FormikFocusError from 'components/FormikFocusError';
import SelectVehicleModelsModal from 'components/InsureProcess/Vehicle/SelectVehicleModelsModal';
import { VehiclePowerValidationExpressionSymbols, VehiclePowerValidationExpressionSymbolsString } from 'constants/enums/vehiclePowerValidationExpressionSymbols.enum';
import { VehiclePolicyStatus } from 'constants/enums/vehiclePolicyStatus.enum';
import VehicleReg from '../VehicleReg/VehicleReg';
import { VehRegResp } from 'bff/models/info/infoVehregdata';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';
import { YesNo } from 'constants/enums/yesNo.enum';

const initFormVal: IVehicleInfoFormValue = {
  VEHICAL_MAKER: '',
  VEHICAL_LOSS_THEFT: false,
  MANUFACTUR_YEAR_MONTH: '',
  ORIGINAL_DATE_ISSUE: '',
  ORIGINAL_DATE_YEAR: '',
  ORIGINAL_DATE_MONTH: '',
  ORIGINAL_DATE_DATE: '',
  ENGINE_DISPLACEMENT: '',
  ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.CubicCm,
  VEHICAL_BRAND: '',
  VEHICAL_BRAND_NAME: '',
  VEHICAL_MODEL: '',
  VEHICAL_MODEL_NAME: '',
  REPLACEMENT_PRICE: '',
  LIMIT: ''
};

let formInitialValues: IVehicleInfoFormValue = initFormVal;

class InsureProcessVehicalInfo extends React.Component<IProps, IVehicleInfoState> {
  private formikRef: any = React.createRef();
  private engineDisplacementUnit: string = initFormVal.ENGINE_DISPLACEMENT_UNIT; // 當前排氣量單位 (供「排氣量或馬力」Field 驗證使用)

  state: IVehicleInfoState = {
    activeBrand: '',
    vehicleBrands: {
      HOT_CHOICE: new Array(0),
      VEHICLE_BRAND: new Array(0)
    },
    brandLossTheftStatus: false,
    vehicleType: {
      VEHICLE_BRAND_ID: '',
      VEHICLE_BRAND_NAME: '',
      VEHICLE_LIST: new Array(0)
    },
    activeVehicleType: '',
    disabledReplacementPrice: true,
    isReplacePriceError: false,
    validLicenseRes: {
      ALLOW_CARBODY_INS: false,
      ALLOW_THIEF_INS: false
    },
    vehiclePowerSysOpts: new Array(0),
    vehicleLossTheftStatus: false,
    vehiclePowerOptions: {
      CC: true,
      HP: true
    },
    vehicleCat: null,
    isMidday: moment().hour() >= 12,
    isUseEcarPlan: false,
    isEcarPlate: this.checkEcarPlate()
  }

  componentDidMount = async () => {
    commonService.scrollToTop();

    const initSetting = await service.fetchInitVehicalInfo(this.props.insTypeId);

    // 解密 F14-079 上行電文
    let regdata: VehRegResp[] = [];
    const ciphertext = storageService.getItem(storageKeys.Vehregdata);
    if (ciphertext) {
      const bytes = AES.decrypt(ciphertext, 'vehicle core protection');
      const dataItem = JSON.parse(bytes.toString(encUtf8));
      if (dataItem) {
        const response = await service.infoVehregdata({ DATA: [dataItem] });
        if (response) {
          regdata = response;
        }
      }
    }

    formInitialValues = {
      ...formInitialValues,
      LIMIT: this.props.insTypeId === InsType.Car ? '' : '2'
    };

    // 有暫存資料，且無續保件資料
    if (this.props.tempVehicleInfo &&
      this.props.tempVehicleInfo.tempVehicleInfoFormValue &&
      this.props.tempVehicleInfo.tempVehicleInfoState &&
      (!this.props.tempVehicleInfo.tempVehicleInfoState.renewVehicle ||
        Object.keys(this.props.tempVehicleInfo.tempVehicleInfoState.renewVehicle).length === 0)) {
      await this.handleInitTempData(regdata, initSetting);

      const tempVehicleOwnerInfoFormValue =
        { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue } as IVehicleOwnerInfoFormValue;

      // 有登入才查續保資料
      if (this.props.fetchFavoriteComplete) {
        // 查詢續保件
        await this.handleFetchRenewal(
          tempVehicleOwnerInfoFormValue.MEMBER_ID,
          `${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`,
          this.props.tempVehicleInfo.tempVehicleInfoState.vehicleBrands.VEHICLE_BRAND,
          tempVehicleOwnerInfoFormValue.VEHICLE_TYPE,
          this.props.renewalInfo?.POLICY_DATA.APPLY_NO ?? null
        );
      }

      return;
    }

    // 有暫存資料，且有續保件資料
    if (this.props.tempVehicleInfo &&
      this.props.tempVehicleInfo.tempVehicleInfoFormValue &&
      this.props.tempVehicleInfo.tempVehicleInfoState) {
      await this.handleInitTempData(regdata, initSetting);
      return;
    }

    // 以下為「無暫存資料」流程
    const tempVehicleOwnerInfoFormValue =
      { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue } as IVehicleOwnerInfoFormValue;

    // 有登入才查續保資料
    let hasRenew = false;
    if (this.props.fetchFavoriteComplete) {
      // 查詢續保件
      hasRenew = await this.handleFetchRenewal(
        tempVehicleOwnerInfoFormValue.MEMBER_ID,
        `${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`,
        initSetting.vehicleBrands.VEHICLE_BRAND,
        tempVehicleOwnerInfoFormValue.VEHICLE_TYPE,
        this.props.renewalInfo?.POLICY_DATA.APPLY_NO ?? null
      );
    }

    // 機車險取得現行的車種，若有核心資料則以核心為主
    const coredata = regdata.find(it => it.ID === this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.MEMBER_ID && it.ISSUCCESS === YesNo.Yes);
    let currentVehicleCar = this.handleGetCurrentVehicleCar();
    if (this.props.insTypeId === InsType.Moto && coredata && coredata.CARKINDCODE && !hasRenew) {
      const vehicleCatId = coredata.CARKINDCODE;
      currentVehicleCar = this.props.vehicleCars.find((vehicleCar: VehicleCar) => vehicleCar.VEHICLECAT_ID === vehicleCatId);
    }
    // 初始化「排氣量或馬力」相關資料
    if (currentVehicleCar) {
      // 屬性「HP」為 null，則切到「立方公分」Radio Button
      // if (currentVehicleCar && currentVehicleCar.CC && !currentVehicleCar.HP) {
      if (!this.state.isEcarPlate) {
        formInitialValues = {
          ...formInitialValues,
          ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.CubicCm
        };
        this.engineDisplacementUnit = VehiclePowerType.CubicCm;
      }

      // 屬性「CC」為 null，則切到「馬力」Radio Button
      // if (currentVehicleCar && !currentVehicleCar.CC && currentVehicleCar.HP) {
      if (this.state.isEcarPlate) {
        formInitialValues = {
          ...formInitialValues,
          ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.Hp
        };
        this.engineDisplacementUnit = VehiclePowerType.Hp;
      }
    }
    // 若有核心資料，則覆蓋至表單，若有續保件，則不覆蓋
    let vehicleType;
    let activeVehicleModel;
    if (coredata && !hasRenew) {
      this.syncFormValuesFromCore(coredata, initSetting);
      if (coredata.ISDMGBRG === YesNo.Yes) {
        const codeTypes = commonService.splitCodeType(coredata.MODELCODE, 2);
        const markCode = codeTypes[0];
        const displacement = +coredata.EXHAUSTSCALE;
        const displacementUnit = this.state.isEcarPlate ? VehiclePowerType.Hp : VehiclePowerType.CubicCm
        const fetchVehicleTypeReq = {
          INS_TYPE_ID: this.props.insTypeId,
          BCODE: markCode,
          DISPLACEMENT: displacement,
          DISPLACEMENT_UNIT: displacementUnit,
          MANUFACTURE: moment(coredata.MAKEDATE).format('YYYYMM'),
          VEHICLECAT_ID: coredata.CARKINDCODE,
          VO_SDATE: this.handleGetVoSDate(this.state.renewVehicle)
        };
        // 查詢廠牌資訊
        const response = await service.fetchVehicleType(fetchVehicleTypeReq);
        if (response) {
          vehicleType = response;
          // 取得廠牌
          const brand = initSetting.vehicleBrands.VEHICLE_BRAND.find(it => it.TYPE_CODE1 === markCode);
          // 取得車系 => 即 UI 上所指的 車款
          const seriesID = codeTypes[1];
          const series = response.VEHICLE_LIST.find(it => it.SERIES_ID === seriesID);
          if (brand && series) {
            // 取得車款
            const fetchVehicleTypeReq = this.getVehicleTypeReq(markCode, displacement, displacementUnit, coredata.MAKEDATE);
            const res = await service.fetchVehicleType(fetchVehicleTypeReq);

            if (res) {
              this.setState({
                vehicleType: { ...res },
                isMidday: moment().hour() >= 12
              });
            }
            // 取得車型
            const model = series.MODEL_LIST.find(it => it.TYPE_CODE.join('') === codeTypes.join(''));
            if (model) {
              activeVehicleModel = model;
              formInitialValues = {
                ...formInitialValues,
                VEHICAL_LOSS_THEFT: true,
                VEHICAL_BRAND: seriesID, // 車款 => 即 UI 上所指的 車款
                VEHICAL_BRAND_NAME: series.SERIES_NAME, // 車款名稱 => 車系名稱
                VEHICAL_MODEL: codeTypes.join(','), // 車型
                VEHICAL_MODEL_NAME: model.NAME, // 車型名稱
                REPLACEMENT_PRICE: model.REPLACEMENT_PRICE, // 重置價格
                LIMIT: model.QPT // 乘載人數
              };
              this.setState({
                isUseEcarPlan: brand.USE_ECAR_PLAN
              });
            }
          }
        }
      }
    }

    // 機車險 - 移除排氣量/馬力規則 (等同停用按鈕的效果)
    let enableVehicleCar;
    if (this.state.isEcarPlate) enableVehicleCar = _.omit(currentVehicleCar, 'CC');
    else enableVehicleCar = _.omit(currentVehicleCar, 'HP');

    // // 初始化「排氣量或馬力」相關資料
    // this.initEngineDisplacementField();

    // 若有核心資料，則更新至狀態，若有續保件，則不覆蓋
    if (coredata && !hasRenew) {
      await this.syncStateFromCore(coredata, initSetting, enableVehicleCar, vehicleType, activeVehicleModel);
      return;
    }

    this.setState({
      vehicleBrands: {
        HOT_CHOICE: [...initSetting.vehicleBrands.HOT_CHOICE],
        VEHICLE_BRAND: [...initSetting.vehicleBrands.VEHICLE_BRAND]
      },
      vehiclePowerSysOpts: [...initSetting.vehiclePowerSysOpts],
      vehicleCat: enableVehicleCar as VehicleCar
    });
  }

  componentDidUpdate () {
    this.handleUpdateVehicleMark();
    // console.log('InsureProcessVehicalInfo componentDidUpdate', this.state);
    // console.log('InsureProcessVehicalInfo componentDidUpdate', JSON.stringify(this.props.tempState));

    // // 初始化「排氣量或馬力」相關資料
    // this.initEngineDisplacementField();
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    let formVal = this.formikRef.current.values;

    const replacementPrice = formVal.REPLACEMENT_PRICE && formVal.REPLACEMENT_PRICE.indexOf(',') !== -1
      ? formVal.REPLACEMENT_PRICE.replace(/[,]/g, '')
      : formVal.REPLACEMENT_PRICE;

    formVal = {
      ...formVal,
      ORIGINAL_DATE_ISSUE: `${formVal.ORIGINAL_DATE_YEAR}${formVal.ORIGINAL_DATE_MONTH}${formVal.ORIGINAL_DATE_DATE}`,
      LIMIT: formVal.LIMIT ? `${Number.parseInt(formVal.LIMIT)}` : formVal.LIMIT,
      REPLACEMENT_PRICE: replacementPrice ? `${Number.parseInt(replacementPrice)}` : ''
    };

    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  // #region 設定續保件相關方法

  /**
   * @description 取得續保件資料，回傳結果 (有續保件: true，無續保件: false)
  */
  handleFetchRenewal = async (memberId: string, licensePlate: string, brands: VehicleBrand[], ownerVehicleType: string, applyNo: string) => {
    const renewalRes = await service.renewalVehicle(this.props.insTypeId, memberId, licensePlate, applyNo);

    if (!renewalRes || !renewalRes.RENEWAL || Object.keys(renewalRes.RENEWAL).length === 0) return false;

    const renewal = { ...renewalRes.RENEWAL };
    if (renewal.IcarType && renewal.IcarType !== ownerVehicleType) {
      await sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W050)
      });
      return false;
    }

    let activeBrand = '';
    let vehicleLossTheftStatus = false;
    let activeVehicleType = '';
    let vehicleType: any = {
      VEHICLE_BRAND_ID: '',
      VEHICLE_BRAND_NAME: '',
      VEHICLE_LIST: new Array(0)
    };

    if (Object.keys(renewal).length > 0) {
      const brandTypeCode = renewal.Ibrand ? renewal.Ibrand.replace(/(.{2})(.{6})/, '$1') : '';
      // 取得廠牌名稱、代碼
      const vehicleBrandInfo = this.handleGetVehicleBrandInfo(brandTypeCode, brands);
      const vehicleMarkName = vehicleBrandInfo?.TI_NAME ?? '';
      const isUseEcarPlan = vehicleBrandInfo?.USE_ECAR_PLAN ?? false;

      // 汽車險 - 查詢汽車排氣量選項
      const vehiclePowerOptions = { ...this.state.vehiclePowerOptions };
      let displacementUnit = VehiclePowerType.CubicCm;
      if (this.props.insTypeId === InsType.Car) {
        const vehiclePowerOptionsStatus = await service.queryPolicyVehiclePdvhpopt(brandTypeCode);
        if (vehiclePowerOptionsStatus) {
          // 設置 State 控制「排氣量或馬力」Radio Button enabled 或是 disabled
          vehiclePowerOptions.CC = !this.state.isEcarPlate;
          vehiclePowerOptions.HP = this.state.isEcarPlate;

          // 「立方公分」Radio Button 為 Disabled，則切回「馬力」Radio Button
          // if (!vehiclePowerOptionsStatus.VEHICLEPOWER_CC && vehiclePowerOptionsStatus.VEHICLEPOWER_HP) {
          if (!vehiclePowerOptions.CC && vehiclePowerOptions.HP) {
            displacementUnit = VehiclePowerType.Hp;
          }
        }
      }

      activeBrand = brandTypeCode;
      // 判斷是否投保車體或竊盜
      vehicleLossTheftStatus = renewalRes.FLAG_HAS_CARBODY || renewalRes.FLAG_HAS_THIEFING;

      // 設定原始發照年月日
      let originalDateYear = '';
      let originalDateMonth = '';
      let originalDateDate = '';
      if (renewal.Nissueym.indexOf('/') !== -1) {
        const originalDateArray = renewal.Nissueym.split('/');

        const yearNum = +originalDateArray[0] - 1911;
        originalDateYear = yearNum < 10
          ? `00${yearNum}`
          : yearNum < 100
            ? `0${yearNum}`
            : `${yearNum}`;
        originalDateMonth = originalDateArray[1];
        originalDateDate = originalDateArray[2];
      }

      // 設定車款、車型資料
      let vehicleBrand = '';
      let vehicleBrandName = '';
      let vehicleModel = '';
      let vehicleModelName = '';
      let activeVehicleModel;
      let replacementPrice;
      // 判斷是否查詢車款車型資料
      const isFetchVehicleType = vehicleLossTheftStatus &&
        renewal.IcarType && renewal.QCYLIN;

      if (isFetchVehicleType) {
        const displacementUnit = renewal.QcylinUnit
          ? renewal.QcylinUnit.toUpperCase()
          : VehiclePowerType.CubicCm;

        const fetchVehicleTypeReq = {
          INS_TYPE_ID: this.props.insTypeId,
          BCODE: brandTypeCode,
          DISPLACEMENT: Number.parseInt(renewal.QCYLIN),
          DISPLACEMENT_UNIT: displacementUnit,
          MANUFACTURE: renewal.IpYm,
          VEHICLECAT_ID: renewal.IcarType,
          VO_SDATE: this.handleGetVoSDate(renewal)
        };

        vehicleType = await service.fetchVehicleType(fetchVehicleTypeReq);
        if (vehicleType) {
          // 取得 車款 資訊
          const vehicleTypeInfo = this.handleGetVehicleBrandType(renewal.Ibrand, vehicleType.VEHICLE_LIST);
          if (vehicleTypeInfo) {
            vehicleBrand = vehicleTypeInfo.SERIES_ID;
            vehicleBrandName = vehicleTypeInfo.SERIES_NAME;
            activeVehicleType = vehicleTypeInfo.SERIES_ID;
            vehicleModel = renewal.Ibrand.replace(/([\dA-Za-z]{2})([\dA-Za-z]{2})([\dA-Za-z]{2})([\dA-Za-z]{2})/, '$1,$2,$3,$4');
            activeVehicleModel = this.handleGetVehicleModel(renewal.Ibrand, vehicleTypeInfo.MODEL_LIST);
            replacementPrice = vehicleTypeInfo.MODEL_LIST.find(item => item.TYPE_CODE.join('') === renewal.Ibrand)?.REPLACEMENT_PRICE;
            // 取得車型名稱
            vehicleModelName = activeVehicleModel ? activeVehicleModel.NAME : '';
          }
        }
      }

      this.engineDisplacementUnit = renewal.QcylinUnit
        ? renewal.QcylinUnit.toUpperCase()
        : displacementUnit;

      formInitialValues = {
        ...formInitialValues,
        VEHICAL_MAKER: vehicleMarkName,
        VEHICAL_LOSS_THEFT: vehicleLossTheftStatus,
        MANUFACTUR_YEAR_MONTH: moment(renewal.IpYm).format('YYYYMM'),
        ORIGINAL_DATE_YEAR: originalDateYear,
        ORIGINAL_DATE_MONTH: originalDateMonth,
        ORIGINAL_DATE_DATE: originalDateDate,
        ENGINE_DISPLACEMENT: `${Number.parseInt(renewal.QCYLIN)}`,
        ENGINE_DISPLACEMENT_UNIT: renewal.QcylinUnit
          ? renewal.QcylinUnit.toUpperCase()
          : displacementUnit,
        VEHICAL_BRAND: vehicleBrand,
        VEHICAL_BRAND_NAME: vehicleBrandName,
        VEHICAL_MODEL: vehicleModel,
        VEHICAL_MODEL_NAME: vehicleModelName,
        // REPLACEMENT_PRICE: commonService.thousandFormat(renewal.QcPrice),
        REPLACEMENT_PRICE: replacementPrice || '',
        LIMIT: `${Number.parseInt(renewal.Qpt)}`
      };

      this.setState({
        activeBrand: activeBrand,
        vehicleLossTheftStatus: this.handleGetVehicleCompulsoryOnlyVal(brandTypeCode, brands),
        activeVehicleType: activeVehicleType,
        vehicleType: vehicleType,
        activeVehicleModel: activeVehicleModel,
        renewVehicle: renewal,
        vehiclePowerOptions: vehiclePowerOptions,
        isMidday: moment().hour() >= 12,
        isUseEcarPlan: isUseEcarPlan
      });
      return true;
    }
    return false;
  }

  /**
   * @description 取得廠牌資訊
   */
  handleGetVehicleBrandInfo = (barndTypeCode: string, brands: VehicleBrand[]) => {
    return _.find(brands, (brand: VehicleBrand) => brand.TYPE_CODE1 === barndTypeCode);
  }

  /**
   * @description 取得是否僅可投保強制險
   */
  handleGetVehicleCompulsoryOnlyVal = (barndTypeCode: string, brands: VehicleBrand[]) => {
    const brand = _.find(brands, (brand: VehicleBrand) => brand.TYPE_CODE1 === barndTypeCode);
    if (!brand) return false;

    return !brand.COMPULSORY_ONLY;
  }

  /**
   * @description 取得 車款 資訊
  */
  handleGetVehicleBrandType = (brandTypeCode: string, vehicleList: VehicleListContent[]) => {
    const vehicleListIndex = _.findIndex(vehicleList, (vehicle: VehicleListContent) => {
      return _.findIndex(vehicle.MODEL_LIST, (modelContent: VehicleModelListContent) => {
        return modelContent.TYPE_CODE.join('') === brandTypeCode;
      }) !== -1;
    });

    return vehicleList[vehicleListIndex];
  }

  /**
   * @description 取得車型名稱
  */
  handleGetVehicleModel = (brandTypeCode: string, vehicleModelList: VehicleModelListContent[]) => {
    const vehicleModel = _.find(vehicleModelList, (vehicleModel: VehicleModelListContent) => {
      return vehicleModel.TYPE_CODE.join('') === brandTypeCode;
    });

    if (!vehicleModel) return;

    return vehicleModel;
  }

  // #endregion

  /**
   * @description 同步核心車籍資料至對應的表單欄位
   * @param coredata 核心車籍資料
   * @param initSetting 初始系統參數
   */
  syncFormValuesFromCore = async (coredata: VehRegResp, initSetting: InitSettingType) => {
    if (!coredata) return;
    const codeTypes = commonService.splitCodeType(coredata.MODELCODE, 2);
    const markCode = codeTypes[0] ?? '';
    // 根據 CODE_TYPE1 查詢車種
    const vehicleBrand = initSetting.vehicleBrands.VEHICLE_BRAND.find(it => it.TYPE_CODE1 === markCode);
    // 處理「製造年月」
    const snippets = coredata.ENROLLDATE.split('-');
    const originalDateYear = `${+snippets[0] - 1911}`.padStart(3, '0');
    // 更新表單初始值
    formInitialValues = {
      ...formInitialValues,
      ENGINE_DISPLACEMENT: coredata.EXHAUSTSCALE.toString(), // 排氣量/馬力
      LIMIT: coredata.SEATCOUNT.toString(), // 承載人數
      MANUFACTUR_YEAR_MONTH: moment(coredata.MAKEDATE).format('YYYYMM'),
      ORIGINAL_DATE_ISSUE: `${originalDateYear}${snippets[1]}${snippets[2]}`,
      ORIGINAL_DATE_YEAR: originalDateYear.toString(),
      ORIGINAL_DATE_MONTH: snippets[1],
      ORIGINAL_DATE_DATE: snippets[2],
      VEHICAL_MAKER: vehicleBrand?.TI_NAME ?? ''
    };
  }

  /**
   * @description 同步核心車籍資料至對應的 state 欄位
   * @param coredata 核心車籍資料
   * @param initSetting 初始系統參數
   * @param enableVehicleCar 機車類型 (若為汽車，則為 undefined)
   * @param vehicleType 由核心資料查詢中台的廠牌資料
   * @param activeVehicleModel 由核心資料比對出的當前車型
   */
  syncStateFromCore = async (coredata: VehRegResp, initSetting: InitSettingType, enableVehicleCar: any, vehicleType?: any, activeVehicleModel?: any) => {
    const codeTypes = commonService.splitCodeType(coredata.MODELCODE, 2);
    if (!codeTypes || codeTypes.length !== 4) return;
    const markCode = codeTypes[0];
    const seriesID = codeTypes[1];
    // 汽車險 - 查詢汽車排氣量選項
    const vehiclePowerOptions = { ...this.state.vehiclePowerOptions };
    if (this.props.insTypeId === InsType.Car) {
      const vehiclePowerOptionsStatus = await service.queryPolicyVehiclePdvhpopt(markCode);
      if (vehiclePowerOptionsStatus) {
        vehiclePowerOptions.CC = !this.state.isEcarPlate;
        vehiclePowerOptions.HP = this.state.isEcarPlate;
        if (vehiclePowerOptions.CC && !vehiclePowerOptions.HP) {
          formInitialValues = {
            ...formInitialValues,
            ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.CubicCm
          };
        }
        if (!vehiclePowerOptions.CC && vehiclePowerOptions.HP) {
          formInitialValues = {
            ...formInitialValues,
            ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.Hp
          };
        }
      }
    }
    // 取得廠牌
    const vehicleBrand = initSetting.vehicleBrands.VEHICLE_BRAND.find(it => it.TYPE_CODE1 === markCode);
    const compulsoryOnly = vehicleBrand?.COMPULSORY_ONLY ?? false;
    if (
      coredata.ISDMGBRG === YesNo.Yes &&
      this.enableLostAndTheftCheckBox(markCode, compulsoryOnly) &&
      vehicleType &&
      activeVehicleModel
    ) {
      this.setState({
        vehicleBrands: {
          HOT_CHOICE: [...initSetting.vehicleBrands.HOT_CHOICE],
          VEHICLE_BRAND: [...initSetting.vehicleBrands.VEHICLE_BRAND]
        },
        vehiclePowerSysOpts: [...initSetting.vehiclePowerSysOpts],
        vehicleCat: enableVehicleCar as VehicleCar,
        activeBrand: markCode,
        activeVehicleType: seriesID, // 車系，即 UI 上所指的 車款
        activeVehicleModel, // 車型
        vehiclePowerOptions,
        vehicleLossTheftStatus: true, // 若核心資料 ISDMGBRG 為 'Y' 且廠牌不為「單強」
        brandLossTheftStatus: compulsoryOnly,
        vehicleType
      });
      return;
    }
    this.setState({
      vehicleBrands: {
        HOT_CHOICE: [...initSetting.vehicleBrands.HOT_CHOICE],
        VEHICLE_BRAND: [...initSetting.vehicleBrands.VEHICLE_BRAND]
      },
      vehiclePowerSysOpts: [...initSetting.vehiclePowerSysOpts],
      vehicleCat: enableVehicleCar as VehicleCar,
      activeBrand: markCode,
      vehiclePowerOptions,
      vehicleLossTheftStatus: this.enableLostAndTheftCheckBox(markCode, compulsoryOnly),
      brandLossTheftStatus: compulsoryOnly
    });
  }

  /**
   * @description 若有從其他廠牌 Modal 選擇，更新 Form 和 State
  */
  handleUpdateVehicleMark = () => {
    if (this.formikRef && this.formikRef.current && this.props.selectItem && this.props.selectItem.TYPE_CODE1) {
      this.handleVehicleMarkClick(this.props.selectItem.TYPE_CODE1, this.props.selectItem.TI_NAME, this.props.selectItem.COMPULSORY_ONLY, this.props.selectItem.USE_ECAR_PLAN);

      this.props.setSelectVehicleBrandsModalVisible(false);
    }
  }

  /**
   * @description 若有暫存資料，帶入暫存資料
  */
  handleInitTempData = async (regdata: VehRegResp[], initSetting: InitSettingType) => {
    const { tempVehicleInfoFormValue, tempVehicleInfoState } = this.props.tempVehicleInfo;
    if (!tempVehicleInfoFormValue || !tempVehicleInfoState) return;

    formInitialValues = {
      ...tempVehicleInfoFormValue,
      REPLACEMENT_PRICE: commonService.thousandFormat(tempVehicleInfoFormValue.REPLACEMENT_PRICE || '')
    } as IVehicleInfoFormValue;

    this.engineDisplacementUnit = tempVehicleInfoFormValue.ENGINE_DISPLACEMENT_UNIT || VehiclePowerType.CubicCm;

    // 機車險取得現行的車種，若有核心資料則以核心為主
    const coredata = regdata.find(it => it.ID === this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.MEMBER_ID && it.ISSUCCESS === YesNo.Yes);
    let currentVehicleCar = this.handleGetCurrentVehicleCar();
    if (this.props.insTypeId === InsType.Moto && coredata && coredata.CARKINDCODE) {
      const vehicleCatId = coredata.CARKINDCODE;
      currentVehicleCar = this.props.vehicleCars.find((vehicleCar: VehicleCar) => vehicleCar.VEHICLECAT_ID === vehicleCatId);
    }
    // 初始化「排氣量或馬力」相關資料
    if (currentVehicleCar) {
      // 屬性「HP」為 null，則切到「立方公分」Radio Button
      // if (currentVehicleCar && currentVehicleCar.CC && !currentVehicleCar.HP) {
      if (!this.state.isEcarPlate) {
        formInitialValues = {
          ...formInitialValues,
          ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.CubicCm
        };
        this.engineDisplacementUnit = VehiclePowerType.CubicCm;
      }

      // 屬性「CC」為 null，則切到「馬力」Radio Button
      // if (currentVehicleCar && !currentVehicleCar.CC && currentVehicleCar.HP) {
      if (this.state.isEcarPlate) {
        formInitialValues = {
          ...formInitialValues,
          ENGINE_DISPLACEMENT_UNIT: VehiclePowerType.Hp
        };
        this.engineDisplacementUnit = VehiclePowerType.Hp;
      }
    }

    // 若緩存資料有勾選「我要投保車體損失險或竊盜損失險」，則以核心資料查詢當前的廠牌及所屬全部的車系、車種資訊
    let vehicleType;
    if (coredata && tempVehicleInfoFormValue.VEHICAL_LOSS_THEFT) {
      const codeTypes = commonService.splitCodeType(coredata.MODELCODE, 2);
      const markCode = codeTypes[0] ?? '';
      const fetchVehicleTypeReq = {
        INS_TYPE_ID: this.props.insTypeId,
        BCODE: markCode,
        DISPLACEMENT: +coredata.EXHAUSTSCALE,
        DISPLACEMENT_UNIT: formInitialValues.ENGINE_DISPLACEMENT_UNIT,
        MANUFACTURE: moment(coredata.MAKEDATE).format('YYYYMM'),
        VEHICLECAT_ID: coredata.CARKINDCODE,
        VO_SDATE: this.handleGetVoSDate(this.state.renewVehicle)
      };
      const response = await service.fetchVehicleType(fetchVehicleTypeReq);
      if (response) {
        vehicleType = response;
      }
    }

    // 若有勾選「我要投保車體損失險或竊盜損失險」，則取得車系、車型資料並覆蓋至表單
    let activeVehicleModel;
    if (coredata) {
      this.syncFormValuesFromCore(coredata, initSetting);
      if (tempVehicleInfoFormValue.VEHICAL_LOSS_THEFT && vehicleType) {
        const codeTypes = commonService.splitCodeType(coredata.MODELCODE, 2);
        // 取得廠牌
        const markCode = codeTypes[0];
        const brand = initSetting.vehicleBrands.VEHICLE_BRAND.find(it => it.TYPE_CODE1 === markCode);
        // 取得車系 => 即 UI 上所指的 車款
        const seriesID = codeTypes[1];
        const series = vehicleType.VEHICLE_LIST.find(it => it.SERIES_ID === seriesID);
        if (brand && series) {
          // 取得車型
          const model = series.MODEL_LIST.find(it => it.TYPE_CODE.join('') === codeTypes.join(''));
          if (model) {
            activeVehicleModel = model;
            formInitialValues = {
              ...formInitialValues,
              VEHICAL_BRAND: seriesID, // 車款 => 即 UI 上所指的 車款
              VEHICAL_BRAND_NAME: series.SERIES_NAME, // 車款名稱 => 車系名稱
              VEHICAL_MODEL: codeTypes.join(','), // 車型
              VEHICAL_MODEL_NAME: model.NAME, // 車型名稱
              REPLACEMENT_PRICE: model.REPLACEMENT_PRICE, // 重置價格
              LIMIT: model.QPT // 乘載人數
            };
          }
        }
      }
    }

    // 機車險 - 移除排氣量/馬力規則 (等同停用按鈕的效果)
    let enableVehicleCar;
    if (this.state.isEcarPlate) enableVehicleCar = _.omit(currentVehicleCar, 'CC');
    else enableVehicleCar = _.omit(currentVehicleCar, 'HP');

    if (coredata) {
      const codeTypes = commonService.splitCodeType(coredata.MODELCODE, 2);
      const markCode = codeTypes[0] ?? '';
      const seriesID = codeTypes[1] ?? '';
      // 若勾選「投保車體損失險或竊盜損失險」，覆蓋車系與車型
      if (tempVehicleInfoFormValue.VEHICAL_LOSS_THEFT && vehicleType && activeVehicleModel) {
        const syncState = {
          ...tempVehicleInfoState,
          activeBrand: markCode, // 廠牌
          activeVehicleType: seriesID, // 車系，即 UI 上所指的 車款
          activeVehicleModel, // 車型
          //vehicleLossTheftStatus: tempVehicleInfoState.activeBrand === 'H4' ? false : tempVehicleInfoState.vehicleLossTheftStatus,
          vehicleType // 再次從中台取得當前的廠牌資訊
        };
        this.setState(syncState);
        return;
      }
      // 無投保車體險或竊盜險，則不需覆蓋車系與車型
      this.setState({
        ...tempVehicleInfoState,
        activeBrand: markCode,
        //vehicleLossTheftStatus: tempVehicleInfoState.activeBrand === 'H4' ? false : tempVehicleInfoState.vehicleLossTheftStatus
      });
      return;
    }

    //* TESLA 暫時 hard code
    const forTeslaTempInfoState = {
      ...tempVehicleInfoState,
      //vehicleLossTheftStatus: tempVehicleInfoState.activeBrand === 'H4' ? false : tempVehicleInfoState.vehicleLossTheftStatus
    };

    // debugger;
    this.setState({
      ...forTeslaTempInfoState,
      // ...tempVehicleInfoState,
      vehicleCat: enableVehicleCar as VehicleCar
    });
  }

  /**
   * @description 取得車款及車型資
   * @param brandVal 廠牌代碼
   * @param lossTheft 是否要投保車體損失險或竊盜損失險
   * @param displacement 排氣量
  */
  handleFetchVehicleType = async (markCode: string, lossTheft: boolean, displacement: string, displacementUnit: string, markDate: any) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const setFieldValue = this.formikRef.current.setFieldValue;

    setFieldValue('VEHICAL_BRAND', '');
    setFieldValue('VEHICAL_MODEL', '');
    setFieldValue('VEHICAL_BRAND_NAME', '');
    setFieldValue('VEHICAL_MODEL_NAME', '');
    setFieldValue('REPLACEMENT_PRICE', '');
    commonService.setSelectOptName(setFieldValue, 'VEHICAL_BRAND_NAME', '');
    commonService.setSelectOptName(setFieldValue, 'VEHICAL_MODEL_NAME', '');
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;

    // 不投保車體損失險或竊盜損失險，不可選取車款及車型
    if (!lossTheft || !markCode || !displacement || !displacementUnit || !markDate || !tempVehicleOwnerInfoFormValue) {
      this.setState({
        vehicleType: {
          VEHICLE_BRAND_ID: '',
          VEHICLE_BRAND_NAME: '',
          VEHICLE_LIST: new Array(0)
        },
        activeVehicleType: ''
      });

      return;
    }

    const fetchVehicleTypeReq = this.getVehicleTypeReq(markCode, +displacement, displacementUnit, markDate)

    const res = await service.fetchVehicleType(fetchVehicleTypeReq);
    if (!res) {
      this.setState({
        vehicleType: {
          VEHICLE_BRAND_ID: '',
          VEHICLE_BRAND_NAME: '',
          VEHICLE_LIST: new Array(0)
        },
        activeVehicleType: '',
        isMidday: moment().hour() >= 12
      });
      return;
    }

    this.setState({
      vehicleType: { ...res },
      isMidday: moment().hour() >= 12
    });

    if (res.VEHICLE_LIST.length === 1) {
      setFieldValue('VEHICAL_BRAND', res.VEHICLE_LIST[0].SERIES_ID);
      setFieldValue('VEHICAL_BRAND_NAME', res.VEHICLE_LIST[0].SERIES_NAME);
      this.setState({ activeVehicleType: res.VEHICLE_LIST[0].SERIES_ID });
    }
  }

  getVehicleTypeReq = (markCode: string, displacement: number, displacementUnit: string, markDate: any) => {
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;

    if (!tempVehicleOwnerInfoFormValue) return;

    return ({
      INS_TYPE_ID: this.props.insTypeId,
      BCODE: markCode,
      DISPLACEMENT: displacement,
      DISPLACEMENT_UNIT: displacementUnit,
      MANUFACTURE: moment(markDate).format('YYYYMM'),
      VEHICLECAT_ID: tempVehicleOwnerInfoFormValue.VEHICLE_TYPE,
      VO_SDATE: this.handleGetVoSDate(this.state.renewVehicle)
    });
  }

  /**
   * @description 取得查詢車型車款用 VO_SDATE 參數值
   */
  handleGetVoSDate = (renewVehicle?: any) => {
    let addDay = 0;
    const momentRes = moment();
    // 判斷是否過 12 點，過 12 點加 1 天
    if (momentRes.hour() >= 12) {
      addDay = 1;
    }

    const { tempVehicleOwnerInfoState } = this.props.tempVehicleOwnerInfo;

    // 無續保資料回傳系統日期
    if (!renewVehicle || Object.keys(renewVehicle).length === 0 || !tempVehicleOwnerInfoState) {
      return momentRes.add(addDay, 'd').format('YYYYMMDD');
    }

    // 有續保資料、任意險狀態不為小於 60 日 = 1，回傳系統時間
    const policyPeriod = tempVehicleOwnerInfoState.policyPeriodRes as ValidVehiclePolicyPeriodRes;
    if (policyPeriod.VOLUNTARY_EXP_STATUS !== VehiclePolicyStatus.UnExpiredMin) {
      return momentRes.add(addDay, 'd').format('YYYYMMDD');
    }

    // 若任意險到期日與系統日相符，回傳系統日
    if (momentRes.format('YYYYMMDD') === moment(policyPeriod.VOLUNTARY_EDATE).format('YYYYMMDD')) {
      return momentRes.add(addDay, 'd').format('YYYYMMDD');
    }

    return moment(policyPeriod.VOLUNTARY_EDATE).format('YYYYMMDD');
  }

  /**
   * @description 設置選取的車型排氣量、重置價格等資訊
   * @param vehicleModel 車型資料
  */
  handleSetVehicleInfo = (vehicleModel: VehicleModelListContent, setFieldValue: any) => {
    if (!this.formikRef || !this.formikRef.current) return;

    if (!vehicleModel || !vehicleModel.TYPE_CODE) {
      setFieldValue('REPLACEMENT_PRICE', '');
      this.setState({ activeVehicleModel: undefined });
      return;
    }

    // 取消設置排氣量
    // let displacement = vehicleModel.DISPLACEMENT;
    // if (displacement) {
    //   if (displacement.indexOf(',') !== -1) {
    //     displacement = displacement.replace(/[,]/g, '');
    //   }

    //   setFieldValue('ENGINE_DISPLACEMENT', +displacement);
    // }

    let replacementPrice = vehicleModel.REPLACEMENT_PRICE;
    if (replacementPrice && typeof replacementPrice === 'string' && replacementPrice.indexOf(',') !== -1) {
      replacementPrice = replacementPrice.replace(/[,]/g, '');
    }

    // const res = await service.fetchVehicleReplacePrice(this.props.insTypeId, typeCode.split(','));
    if (replacementPrice && +replacementPrice === 0) {
      this.setState({ disabledReplacementPrice: false });
      setFieldValue('REPLACEMENT_PRICE', replacementPrice);
      this.formikRef.current.setFieldTouched('REPLACEMENT_PRICE', false);
      return;
    }

    if (replacementPrice && +replacementPrice > 0) {
      this.setState({ disabledReplacementPrice: true });
      setFieldValue('REPLACEMENT_PRICE', commonService.thousandFormat(replacementPrice));
      this.formikRef.current.setFieldTouched('REPLACEMENT_PRICE', false);
      this.handleReplacePriceChange(`${replacementPrice}`);
      return;
    }

    if (!replacementPrice) {
      this.setState({ disabledReplacementPrice: false });
    }
  }

  /**
   * @description 設定乘載人數
   * @param typeCode 車型資料
  */
  handleFetchLIMIT = (typeCode: string, setFieldValue: any) => {
    const vehicle = _.find(this.state.vehicleType.VEHICLE_LIST, (listContent: VehicleListContent, index: number) => {
      return this.state.activeVehicleType === listContent.SERIES_ID;
    });

    if (!vehicle || !this.formikRef || !this.formikRef.current) return;

    const vehicleModel = _.find(vehicle.MODEL_LIST, (model: VehicleModelListContent, index: number) => {
      return model.TYPE_CODE.join(',') === typeCode;
    });

    this.setState({ activeVehicleModel: vehicleModel });

    if (!vehicleModel) return;

    let qpt;
    switch (vehicleModel.FPT) {
      case 'P':
        qpt = Number.parseFloat(vehicleModel.QPT).toFixed(0);
        break;
      case 'T':
        qpt = Number.parseFloat(vehicleModel.QPT).toFixed(1);
        break;
    }

    setFieldValue('LIMIT', qpt);
    this.formikRef.current.setFieldTouched('LIMIT', false);
  }

  /**
   * @description 選擇車型後，依據 TYPE_CODE 最後一碼數字切換「排氣量或馬力」Radio Button 值 (0 = 立方公分，1 = 馬力)
   */
  selectVehicleModelChangePowerOption = (typeCodeLast: string, setFieldValue: FormikHelpers<any>['setFieldValue']) => {
    const lastCode = typeCodeLast.substring(1);

    switch (lastCode) {
      // 立方公分
      case VehiclePowerCode.CubicCm:
        setFieldValue('ENGINE_DISPLACEMENT_UNIT', VehiclePowerType.CubicCm);
        break;
      // 馬力
      case VehiclePowerCode.Hp:
        setFieldValue('ENGINE_DISPLACEMENT_UNIT', VehiclePowerType.Hp);
        break;
    }
  }

  /**
   * @description 取得車型對應的排氣量
  */
  handleGetDisplacement = (typeCode: string) => {
    const vehicle = _.find(this.state.vehicleType.VEHICLE_LIST, (listContent: VehicleListContent) =>
      this.state.activeVehicleType === listContent.SERIES_ID);
    if (!vehicle) return '0';

    const model = _.find(vehicle.MODEL_LIST, (model: VehicleModelListContent) => model.TYPE_CODE.join(',') === typeCode);
    if (!model) return '0';

    return model.DISPLACEMENT;
  }

  /**
   * @description 重置價格輸入事件
  */
  handleReplacePriceChange = (val: string) => {
    if (!val || val.length < 7 || +val <= 6000000) {
      this.setState({ isReplacePriceError: false });
      return;
    };

    sweetAlertService.modal({
      icon: SweetAlertIcon.Info,
      html: commonService.getCodeMsg(this.props.UICodes, CodeId.W022)
    });

    this.setState({ isReplacePriceError: true });
  }

  /**
   * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: IVehicleInfoFormValue) => {
    const manufacturDate = moment(values.MANUFACTUR_YEAR_MONTH).format('YYYYMM');

    const originalIssue = `${values.ORIGINAL_DATE_YEAR}${values.ORIGINAL_DATE_MONTH}${values.ORIGINAL_DATE_DATE}`;
    const originalDate = originalIssue;

    const req: ValidLicenseReq = {
      MANUFACTURE_DATE: manufacturDate,
      ORIGINAL_LICENSE_ISSUE_DATE: originalDate
    };

    const res = await service.validLicense(req);
    if (!res) return;

    const state: IVehicleInfoState = {
      ...this.state,
      validLicenseRes: { ...res }
    };

    const replacementPrice = values.REPLACEMENT_PRICE && values.REPLACEMENT_PRICE.indexOf(',') !== -1
      ? values.REPLACEMENT_PRICE.replace(/[,]/g, '')
      : values.REPLACEMENT_PRICE;

    const formVal: IVehicleInfoFormValue = {
      ...values,
      ORIGINAL_DATE_ISSUE: originalIssue,
      LIMIT: `${Number.parseInt(values.LIMIT)}`,
      REPLACEMENT_PRICE: replacementPrice ? `${Number.parseInt(replacementPrice)}` : ''
    };

    this.setState({ ...state });

    this.props.onVehicleInfoSubmit(formVal, state);
  }

  /**
   * @description 返回上一頁事件
  */
  handleGoBack = (values: IVehicleInfoFormValue) => {
    const originalIssue = `${values.ORIGINAL_DATE_YEAR}${values.ORIGINAL_DATE_MONTH}${values.ORIGINAL_DATE_DATE}`;

    const formVal: IVehicleInfoFormValue = {
      ...values,
      ORIGINAL_DATE_ISSUE: originalIssue
    };

    // 返回上一頁清除續保件暫存
    const state: IVehicleInfoState = {
      ...this.state,
      renewVehicle: undefined
    };

    this.setState({ ...state });

    this.props.onGoBack(formVal, state);
  }

  /**
   * @description 如何填寫
   */
  handlePreviewFillExample = () => {
    this.props.setFillExampleModalVisible(true);
  }

  /**
   * @description 設定選擇車廠與名稱
  */
  handleVehicleMarkClick = async (markCode: string, markName: string, compulsoryOnly: boolean, isUseEcarPlan: boolean) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = { ...this.formikRef.current.values } as IVehicleInfoFormValue;
    const setFieldValue = this.formikRef.current.setFieldValue;

    if (formVal.MANUFACTUR_YEAR_MONTH) {
      setFieldValue('MANUFACTUR_YEAR_MONTH', '');
      // setFieldValue('ORIGINAL_DATE_MONTH', month < 10 ? `0${month}` : `${month}`);
    }

    //* TESLA 暫時 hard code
    // if (markCode === 'H4') {
    //   setFieldValue('VEHICAL_LOSS_THEFT', false);
    // }
    // 判斷是否僅能投保強制險
    // 是: 清空 車款、車型、重置價格 資料
    // 否: 執行查詢取得車款及車型資
    if (compulsoryOnly) {
      setFieldValue('VEHICAL_BRAND', '');
      setFieldValue('VEHICAL_MODEL', '');
      setFieldValue('VEHICAL_BRAND_NAME', '');
      setFieldValue('VEHICAL_MODEL_NAME', '');
      setFieldValue('REPLACEMENT_PRICE', '');
      setFieldValue('VEHICAL_LOSS_THEFT', false);
      commonService.setSelectOptName(setFieldValue, 'VEHICAL_BRAND_NAME', '');
      commonService.setSelectOptName(setFieldValue, 'VEHICAL_MODEL_NAME', '');
    } else {
      await this.handleFetchVehicleType(markCode, formVal.VEHICAL_LOSS_THEFT, formVal.ENGINE_DISPLACEMENT, formVal.ENGINE_DISPLACEMENT_UNIT, formVal.MANUFACTUR_YEAR_MONTH);
    }

    // 汽車險 - 查詢汽車排氣量選項
    const vehiclePowerOptions = { ...this.state.vehiclePowerOptions };
    if (this.props.insTypeId === InsType.Car) {
      const vehiclePowerOptionsStatus = await service.queryPolicyVehiclePdvhpopt(markCode);
      if (vehiclePowerOptionsStatus) {
        // 設置 State 控制「排氣量或馬力」Radio Button enabled 或是 disabled
        vehiclePowerOptions.CC = !this.state.isEcarPlate;
        vehiclePowerOptions.HP = this.state.isEcarPlate;
        // 「馬力」Radio Button 為 Disabled，則切回「立方公分」Radio Button
        // if (vehiclePowerOptionsStatus.VEHICLEPOWER_CC && !vehiclePowerOptionsStatus.VEHICLEPOWER_HP) {
        if (vehiclePowerOptions.CC && !vehiclePowerOptions.HP) {
          setFieldValue('ENGINE_DISPLACEMENT_UNIT', VehiclePowerType.CubicCm);
        }
        // 「立方公分」Radio Button 為 Disabled，則切回「馬力」Radio Button
        // if (!vehiclePowerOptionsStatus.VEHICLEPOWER_CC && vehiclePowerOptionsStatus.VEHICLEPOWER_HP) {
        if (!vehiclePowerOptions.CC && vehiclePowerOptions.HP) {
          setFieldValue('ENGINE_DISPLACEMENT_UNIT', VehiclePowerType.Hp);
        }
      }
    }

    setFieldValue('VEHICAL_MAKER', markName);
    // setFieldValue('VEHICAL_LOSS_THEFT', !compulsoryOnly);
    setFieldValue('ENGINE_DISPLACEMENT', '');

    this.setState({
      activeBrand: markCode,
      vehicleLossTheftStatus: this.enableLostAndTheftCheckBox(markCode, compulsoryOnly),
      brandLossTheftStatus: compulsoryOnly,
      vehiclePowerOptions: vehiclePowerOptions,
      isUseEcarPlan
    });
    // this.setState({
    //   activeBrand: markCode,
    //   vehicleLossTheftStatus: !compulsoryOnly,
    //   brandLossTheftStatus: compulsoryOnly,
    //   vehiclePowerOptions: vehiclePowerOptions,
    //   isUseEcarPlan
    // });
  }

  /**
   * @description 產生年分選單 Option
  */
  handleCreateYearOpt = (manufactureDate: any) => {
    const opts = new Array(0);
    let minYear = 0;
    const maxYears = moment().year() - 1911;
    if (manufactureDate) {
      minYear = moment(manufactureDate).year() - 1911;
    }

    for (let i = minYear; i <= maxYears; i += 1) {
      const val = i < 10 ? `00${i}` : i < 100 ? `0${i}` : `${i}`;
      opts.push(
        <option value={val} key={i}>{`${i}年`}</option>
      );
    }

    return opts;
  }

  /**
   * @description 建立原始發照日期-月份選單
  */
  handleCreateOriginalMonthOpts = (manufactureDate: any, originalYear: string) => {
    const opts = new Array(0);
    let min = 1;
    let max = 12;

    const nowYear = moment().year();

    if (manufactureDate) {
      const manufactureYear = moment(manufactureDate).year();
      const manufactureMonth = moment(manufactureDate).month() + 1;

      min = manufactureMonth;
      if (nowYear - manufactureYear === 0) {
        min = manufactureMonth;
        max = moment().month() + 1;
      }
    }

    if (originalYear) {
      const originalYearNum = +originalYear + 1911;
      if (nowYear - originalYearNum === 0) {
        max = moment().month() + 1;
      }
      const manufactureYear = moment(manufactureDate).year();
      if (manufactureDate && originalYearNum - manufactureYear !== 0) {
        min = 1;
      }
    }

    for (let i = min; i <= max; i += 1) {
      opts.push(
        <option value={i < 10 ? `0${i}` : `${i}`} key={i}>{`${i}月`}</option>
      );
    }

    return opts;
  }

  /**
   * @description 建立原始發照日期-日期選單
  */
  handleCreateOriginalDateOpts = (manufactureDate: any, originalYear: string, originalMonth: string) => {
    const opts = new Array(0);
    const greaterMonth = [1, 3, 5, 7, 8, 10, 12];
    const commonMonth = [4, 6, 9, 11];
    const nowYear = moment().year();
    const nowMonth = moment().month() + 1;
    let max = 31;

    if (manufactureDate) {
      const manufactureYear = moment(manufactureDate).year();
      const manufactureMonth = moment(manufactureDate).month() + 1;
      max = greaterMonth.indexOf(manufactureMonth) !== -1
        ? 31
        : commonMonth.indexOf(manufactureMonth) !== -1
          ? 30
          : manufactureYear % 4 === 0
            ? 29
            : 28;

      if (nowYear - manufactureYear === 0 && nowMonth - manufactureMonth === 0) {
        max = moment().date();
      }
    }

    if (originalYear && originalMonth) {
      const year = (+originalYear + 1911);
      const month = +originalMonth;

      max = greaterMonth.indexOf(+originalMonth) !== -1
        ? 31
        : commonMonth.indexOf(+originalMonth) !== -1
          ? 30
          : (+originalYear + 1911) % 4 === 0
            ? 29
            : 28;

      if (nowYear - year === 0 && nowMonth - month === 0) {
        max = moment().date();
      }
    }

    for (let i = 1; i <= max; i += 1) {
      opts.push(
        <option value={i < 10 ? `0${i}` : `${i}`} key={i}>{`${i}日`}</option>
      );
    }

    return opts;
  }

  /**
   * @description 製造年月 Change 事件
  */
  handleYearMonthChange = (val: any, setFieldValue: any, setFieldTouched: any) => {
    setFieldTouched('ORIGINAL_DATE_YEAR', false);
    setFieldTouched('ORIGINAL_DATE_MONTH', false);
    setFieldTouched('ORIGINAL_DATE_DATE', false);
    setFieldValue('VEHICAL_BRAND', '');
    setFieldValue('VEHICAL_MODEL', '');
    setFieldValue('VEHICAL_BRAND_NAME', '');
    setFieldValue('VEHICAL_MODEL_NAME', '');
    setFieldValue('REPLACEMENT_PRICE', '');
    setFieldValue('ENGINE_DISPLACEMENT', '');
    commonService.setSelectOptName(setFieldValue, 'VEHICAL_BRAND_NAME', '');
    commonService.setSelectOptName(setFieldValue, 'VEHICAL_MODEL_NAME', '');

    // this.setState({ activeVehicleType: '', isReplacePriceError: false });

    if (!val) {
      setFieldValue('ORIGINAL_DATE_YEAR', '');
      setFieldValue('ORIGINAL_DATE_MONTH', '');
      setFieldValue('ORIGINAL_DATE_DATE', '');
      this.setState({
        vehicleLossTheftStatus: this.enableLostAndTheftCheckBox(this.state.activeBrand, this.state.brandLossTheftStatus),
        activeVehicleType: '',
        vehicleType: {
          VEHICLE_BRAND_ID: '',
          VEHICLE_BRAND_NAME: '',
          VEHICLE_LIST: new Array(0)
        }
      });
      return;
    }

    const year = moment(val).year();
    const month = moment(val).month() + 1;
    const yearDiff = year - 1911;
    const yearStr = yearDiff < 10 ? `00${yearDiff}` : yearDiff < 100 ? `0${yearDiff}` : `${yearDiff}`;
    const monthStr = month < 10 ? `0${month}` : `${month}`;

    this.setState({
      vehicleLossTheftStatus: this.enableLostAndTheftCheckBox(this.state.activeBrand, this.state.brandLossTheftStatus),
      activeVehicleType: '',
      vehicleType: {
        VEHICLE_BRAND_ID: '',
        VEHICLE_BRAND_NAME: '',
        VEHICLE_LIST: new Array(0)
      }
    });
    setFieldValue('ORIGINAL_DATE_YEAR', yearStr);
    setFieldValue('ORIGINAL_DATE_MONTH', monthStr);
    setFieldValue('ORIGINAL_DATE_DATE', '01');
  }

  /**
   * @description 原始發照日年份更改事件
  */
  // handleOriginalYearChange = (val: string, manufactureDate: any, setFieldValue: any) => {
  //   if (!val) {
  //     setFieldValue('ORIGINAL_DATE_MONTH', '');
  //     setFieldValue('ORIGINAL_DATE_DATE', '');
  //     return;
  //   }

  //   const originalYearNum = +val + 1911;
  //   let originalMonth = '01';
  //   if (manufactureDate) {
  //     const manufacturYear = moment(manufactureDate).year();
  //     if (originalYearNum - manufacturYear === 0) {
  //       const month = moment(manufactureDate).month() + 1;
  //       originalMonth = month < 10 ? `0${month}` : `${month}`;
  //       setFieldValue('ORIGINAL_DATE_MONTH', originalMonth);
  //       setFieldValue('ORIGINAL_DATE_DATE', '01');

  //       // 若大於 6 個月不可勾選 我要投保車體損失險或竊盜損失險 項目
  //       this.handleValidDate(`${+originalYearNum}${originalMonth}`, manufactureDate, setFieldValue);
  //       return;
  //     }
  //   }

  //   setFieldValue('ORIGINAL_DATE_MONTH', '01');
  //   setFieldValue('ORIGINAL_DATE_DATE', '01');
  //   originalMonth = '01';

  //   // 若大於 6 個月不可勾選 我要投保車體損失險或竊盜損失險 項目
  //   this.handleValidDate(`${+originalYearNum}${originalMonth}`, manufactureDate, setFieldValue);
  // }

  /**
   * @description 原始發照日月份更改事件
  */
  // handleOriginalMonthChange = (originalYear: string, val: string, manufactureDate: any, setFieldValue: any) => {
  //   // 若僅能投保強制險，就不計算原始發照日與製造年月的月份差距
  //   if (this.state.brandLossTheftStatus) return;

  //   if (!manufactureDate || !val || !originalYear) {
  //     this.setState({
  //       vehicleLossTheftStatus: this.enableLostAndTheftCheckBox(this.state.activeBrand, this.state.brandLossTheftStatus)
  //     });
  //     setFieldValue('ORIGINAL_DATE_DATE', '01');
  //     return;
  //   }
  //   setFieldValue('ORIGINAL_DATE_DATE', '01');
  //   // const manufacturMonth = moment(manufactureDate).month() + 1;
  //   // const originalMonth = +val;

  //   // 若大於 6 個月不可勾選 我要投保車體損失險或竊盜損失險 項目
  //   this.handleValidDate(`${+originalYear + 1911}${val}`, manufactureDate, setFieldValue);
  // }

  /**
   * @description 檢核原始發照日與製造年月是否相差六個月
  */
  handleValidDate = (originalDate: any, manufacturDate: any, setFieldValue: any) => {
    const isOver = moment(originalDate).isAfter(moment(manufacturDate).add(6, 'M'));

    // let vehicleLossTheftStatus = !this.state.brandLossTheftStatus;
    let allowVehicleLossTheftStatus = this.enableLostAndTheftCheckBox(this.state.activeBrand, this.state.brandLossTheftStatus);

    // 若大於 6 個月不可勾選 我要投保車體損失險或竊盜損失險 項目
    if (isOver) {
      setFieldValue('VEHICAL_BRAND', '');
      setFieldValue('VEHICAL_MODEL', '');
      setFieldValue('VEHICAL_BRAND_NAME', '');
      setFieldValue('VEHICAL_MODEL_NAME', '');
      setFieldValue('REPLACEMENT_PRICE', '');
      setFieldValue('VEHICAL_LOSS_THEFT', false);
      commonService.setSelectOptName(setFieldValue, 'VEHICAL_BRAND_NAME', '');
      commonService.setSelectOptName(setFieldValue, 'VEHICAL_MODEL_NAME', '');
      allowVehicleLossTheftStatus = false;
      this.props.insTypeId === InsType.Car && sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W053)
      });
    }
    this.setState({
      vehicleLossTheftStatus: allowVehicleLossTheftStatus
    });
  }

  /**
   * @description 排氣量單位切換事件
  */
  handleDisplacementUnitClick = (val: string) => {
    if (!this.formikRef || !this.formikRef.current) return;

    // 設置當前排氣量單位 (供「排氣量或馬力」Field 驗證使用)
    this.engineDisplacementUnit = val;

    const formVal = { ...this.formikRef.current.values } as IVehicleInfoFormValue;
    if (!this.state.activeBrand || !formVal.VEHICAL_LOSS_THEFT || !formVal.ENGINE_DISPLACEMENT || !val) return;

    this.handleFetchVehicleType(this.state.activeBrand, formVal.VEHICAL_LOSS_THEFT, formVal.ENGINE_DISPLACEMENT, val, formVal.MANUFACTUR_YEAR_MONTH);
  }

  /**
   * @description 取得選取的機車類型
   */
  handleGetCurrentVehicleCar = () => {
    if (this.props.insTypeId === InsType.Car) return;

    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    if (!tempVehicleOwnerInfoFormValue) return;

    const vehicleType = tempVehicleOwnerInfoFormValue.VEHICLE_TYPE;
    const currentVehicleCar = this.props.vehicleCars.find((vehicleCar: VehicleCar) => vehicleCar.VEHICLECAT_ID === vehicleType);

    return currentVehicleCar;
  }

  // /**
  //  * @description 初始化「排氣量或馬力」相關資料
  //  */
  // initEngineDisplacementField = () => {
  //   if (!this.formikRef || !this.formikRef.current || this.props.insTypeId === InsType.Car) return;
  //   const setFieldValue = this.formikRef.current.setFieldValue;

  //   const vehicleCatId = this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.VEHICLE_TYPE;
  //   const currentVehicleCar = this.props.vehicleCars.find((vehicleCat: VehicleCar) => vehicleCat.VEHICLECAT_ID === vehicleCatId);

  //   // 將當前的「車輛種類」相關資料存至 State
  //   if (currentVehicleCar && currentVehicleCar.VEHICLECAT_ID !== this.state.vehicleCat?.VEHICLECAT_ID) {
  //     this.setState({ vehicleCat: currentVehicleCar });
  //   }
  //   // 屬性「HP」為 null，則切到「立方公分」Radio Button
  //   if (currentVehicleCar && currentVehicleCar.CC && !currentVehicleCar.HP) {
  //     setFieldValue('ENGINE_DISPLACEMENT_UNIT', VehiclePowerType.CubicCm);
  //   }
  //   // 屬性「CC」為 null，則切到「馬力」Radio Button
  //   if (currentVehicleCar && !currentVehicleCar.CC && currentVehicleCar.HP) {
  //     setFieldValue('ENGINE_DISPLACEMENT_UNIT', VehiclePowerType.Hp);
  //   }
  // }

  /**
   * @description 機車險 - 驗證「排氣量或馬力」(依據檢核規則驗證)
   */
  validateEngineDisplacementField = (engineDisplacement: string) => {
    if (this.props.insTypeId === InsType.Moto && this.state.vehicleCat) {
      const engineDisplacementValue = +engineDisplacement;
      const checkCondition = this.state.vehicleCat[this.engineDisplacementUnit] as VehiclePowerValidationCondition;
      if (!checkCondition) return;

      let expression1st;
      let expression2nd;
      let expSymStr1st;
      let expSymStr2nd;

      switch (checkCondition.TYPE_MIN) {
        case VehiclePowerValidationExpressionSymbols.GT:
          expression1st = engineDisplacementValue > checkCondition.MIN;
          expSymStr1st = VehiclePowerValidationExpressionSymbolsString.GT;
          break;
        case VehiclePowerValidationExpressionSymbols.GE:
          expression1st = engineDisplacementValue >= checkCondition.MIN;
          expSymStr1st = VehiclePowerValidationExpressionSymbolsString.GE;
          break;
      }

      switch (checkCondition.TYPE_MAX) {
        case VehiclePowerValidationExpressionSymbols.LT:
          expression2nd = engineDisplacementValue < checkCondition.MAX;
          expSymStr2nd = VehiclePowerValidationExpressionSymbolsString.LT;
          break;
        case VehiclePowerValidationExpressionSymbols.LE:
          expression2nd = engineDisplacementValue <= checkCondition.MAX;
          expSymStr2nd = VehiclePowerValidationExpressionSymbolsString.LE;
          break;
      }

      return !(expression1st && expression2nd) ? `需${expSymStr1st} ${checkCondition.MIN}，${expSymStr2nd} ${checkCondition.MAX}` : '';
    }
  }

  /**
   * @description 是否啟用投保車體或竊盜險勾選(含 TESLA 檢核)
   * @param markCode 車款
   * @param brandLossTheftStatus 廠牌設定是否允許投保車體險或竊盜險，即是否為「單強」廠牌 (是: true，否: false)
   */
  enableLostAndTheftCheckBox = (markCode: string, brandLossTheftStatus: boolean) => {
    let isAllowed = true;
    // 檢核車款是否為 TESLA
    //if (markCode === 'H4') return false;
    // 檢核車種
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    if (tempVehicleOwnerInfoFormValue) {
      const vehicleType = tempVehicleOwnerInfoFormValue.VEHICLE_TYPE;
      const find = this.props.vehicleLimit.find(it => it.PARAM_ID === 'VEHICLES');
      if (find) {
        isAllowed = !(find.PARAM_VALUE.split(',').includes(vehicleType));
      }
    }
    // 車種檢核通過且不為 TESLA，則轉換廠牌設定作為最後結果
    if (isAllowed) {
      isAllowed = !brandLossTheftStatus;
    }
    return isAllowed;
  }

  /**
   * @description 檢核車牌是否為電動車格式
   */
  checkEcarPlate () {
    const tempVehicleOwnerInfoFormValue =
      { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue } as IVehicleOwnerInfoFormValue;
    if (!tempVehicleOwnerInfoFormValue) return false;

    const plateNum = `${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`;
    const vehicleType = `E${tempVehicleOwnerInfoFormValue.VEHICLE_TYPE}_01`;
    const format = this.props.pNoFormat.find(it => it.PARAM_ID === vehicleType);
    if (!format) return false;

    const regex = new RegExp(format.PARAM_VALUE);
    return regex.test(plateNum);
  }

  render () {
    const formValidationSchema = Yup.object().shape({
      VEHICAL_MAKER: Yup.string().required('請選擇廠牌'),
      MANUFACTUR_YEAR_MONTH: Yup.string().required('此為必填欄位').nullable(),
      ORIGINAL_DATE_YEAR: Yup.string().required('此為必填欄位'),
      ORIGINAL_DATE_MONTH: Yup.string().required('此為必填欄位'),
      ORIGINAL_DATE_DATE: Yup.string().required('此為必填欄位'),
      VEHICAL_BRAND: Yup.string().when('VEHICAL_LOSS_THEFT', (isLossTheft: boolean, schema: any) => {
        return isLossTheft && (this.props.insTypeId === InsType.Car || this.props.insTypeId === InsType.Moto)? schema.required('此為必填欄位') : schema;
      }),
      VEHICAL_MODEL: Yup.string().when('VEHICAL_LOSS_THEFT', (isLossTheft: boolean, schema: any) => {
        return isLossTheft && (this.props.insTypeId === InsType.Car || this.props.insTypeId === InsType.Moto) ? schema.required('此為必填欄位') : schema;
      }),
      ENGINE_DISPLACEMENT: Yup.string().required('此為必填欄位').test('than 0', '排氣量或馬力需大於 0', (val: string) => {
        if (val) {
          return +val > 0;
        }

        return true;
      }),
      LIMIT: Yup.string().required('此為必填欄位').test('than 0', '乘載限制需大於 0', (val: string) => {
        if (val) {
          return +val > 0;
        }

        return true;
      }),
      REPLACEMENT_PRICE: Yup.string().when('VEHICAL_LOSS_THEFT', (isLossTheft: boolean, schema: any) => {
        return isLossTheft && (this.props.insTypeId === InsType.Car || this.props.insTypeId === InsType.Moto)
          ? schema.required('此為必填欄位').test('than 0', '重置價格需大於 0', (val: string) => {
            if (val) {
              const newVal = val.indexOf(',') !== -1 ? val.replace(/[,]/g, '') : val;
              return +newVal > 0;
            }

            return true;
          })
          : schema;
      })
    });

    const { type } = this.props;

    // #region 建立 選擇廠牌 廠牌圖案
    const vehicleBrandList = new Array(0);
    if (this.state.vehicleBrands && this.state.vehicleBrands.VEHICLE_BRAND && this.state.vehicleBrands.VEHICLE_BRAND.length > 0) {
      // 篩選熱門項目、建立熱門項目
      const vehicleHotChoice = _.filter(this.state.vehicleBrands.VEHICLE_BRAND, (vehicleBrand: VehicleBrand) => {
        return this.state.vehicleBrands.HOT_CHOICE.indexOf(vehicleBrand.TYPE_CODE1) !== -1;
      });

      _.forEach(this.state.vehicleBrands.HOT_CHOICE, (hotVal: string, index: number) => {
        const vehicleInfo = _.find(vehicleHotChoice, (vehicleBrand: VehicleBrand, index: number) => vehicleBrand.TYPE_CODE1 === hotVal);

        if (!vehicleInfo) return;

        const className = this.state.activeBrand === vehicleInfo.TYPE_CODE1
          ? 'vehical-info__maker-item vehical-info__maker-item--selected'
          : 'vehical-info__maker-item';

        vehicleBrandList.push(
          <div
            className={className}
            key={index}
            onClick={() => this.handleVehicleMarkClick(vehicleInfo.TYPE_CODE1, vehicleInfo.TI_NAME, vehicleInfo.COMPULSORY_ONLY, vehicleInfo.USE_ECAR_PLAN)}
          >
            <div className="vehical-info__maker-logo" style={{ backgroundImage: vehicleInfo.BLOGO ? `url(${vehicleInfo.BLOGO})` : '' }} />
            <span>{vehicleInfo.TI_NAME}</span>
          </div>
        );
      });

      vehicleBrandList.push(
        <div
          className="vehical-info__else-maker"
          key="other"
          onClick={() => this.props.setSelectVehicleBrandsModalVisible(true, this.state.vehicleBrands.VEHICLE_BRAND)}
        >
          <div className="vehical-info__else-maker-icon" />
          <span>其他</span>
        </div>
      );
    }

    // #endregion

    // #region 建立 車款與車型下拉選單

    let vehicleTypeList: any;
    // let vehicleTypeModels:any;
    let vehicleModels: VehicleModelListContent[] = [];
    if (this.state.vehicleType && this.state.vehicleType.VEHICLE_LIST.length > 0) {
      vehicleTypeList = _.map(this.state.vehicleType.VEHICLE_LIST, (listContent: VehicleListContent, index: number) => {
        if (this.state.activeVehicleType === listContent.SERIES_ID) {
          // vehicleTypeModels = _.map(listContent.MODEL_LIST, (model:VehicleModelListContent, index:number) => {
          //   return <option value={model.TYPE_CODE.join(',')} key={index}>{model.NAME}</option>;
          // });
          vehicleModels = _.cloneDeep(listContent.MODEL_LIST);
        }

        return <option value={listContent.SERIES_ID} key={index}>{listContent.SERIES_NAME}</option>;
      });
    }

    // #endregion

    // #region 建立排氣量單位區塊
    let vehiclePower: any;
    if (this.state.vehiclePowerSysOpts.length > 0) {
      vehiclePower = _.map(this.state.vehiclePowerSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`${sysOpt.PARAM_VALUE}-radio`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="ENGINE_DISPLACEMENT_UNIT"
                  id={`${sysOpt.PARAM_VALUE}-radio`}
                  value={sysOpt.PARAM_VALUE}
                  onClick={(e: React.ChangeEvent<HTMLInputElement>) => this.handleDisplacementUnitClick(e.currentTarget.value)}
                  disabled={
                    (this.props.insTypeId === InsType.Car && !this.state.vehiclePowerOptions[sysOpt.PARAM_VALUE]) ||
                    (this.props.insTypeId === InsType.Moto && this.state.vehicleCat && !this.state.vehicleCat[sysOpt.PARAM_VALUE])
                  }
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    }
    // #endregion

    return (
      <div className="insure-process-vehical-info">
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={this.handleFormSubmit}
          enableReinitialize
          innerRef={this.formikRef}
        >
          {({ errors, touched, handleChange, handleBlur, setFieldValue, setFieldTouched, values }) => (
            <Form>
              <div className="insure-process-vehical-info__content">
                {/* 車籍資料 */}
                <div className="vehical-info">
                  <div className="vehical-info__title">
                    <span>車籍資料</span>
                    <span className="element__link" onClick={this.handlePreviewFillExample}>(如何填寫)</span>
                  </div>
                  <div className="vehical-info__content">
                    <div className="vehical-info__form">
                      <div className="element__form-table">
                        <div className="element__form-table-tr maker">
                          <div className="element__form-table-td">
                            {/* 選擇廠牌 */}
                            <div className={'element__form-group' + (errors.VEHICAL_MAKER && touched.VEHICAL_MAKER ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title" data-fieldname="VEHICAL_MAKER" tabIndex={1} style={{ outline: 'none' }}>選擇廠牌*</div>
                              <Field
                                type="text"
                                name="VEHICAL_MAKER"
                                className="element__input"
                                disabled
                              />
                              <div className="element__error-message">
                                <ErrorMessage name="VEHICAL_MAKER" />
                              </div>
                            </div>
                            {/* 廠牌列表 */}
                            <div className="vehical-info__maker-list">
                              {vehicleBrandList}
                            </div>
                            {/* 我要投保車體損失險或竊盜損失險 */}
                            {(type === InsTypeDefinesEN[InsTypeEnum.Car] || type === InsTypeDefinesEN[InsTypeEnum.Moto]) && (
                              <div className="element__checkbox-group" id="vehical-loss-theft-ins-checkbox-group">
                                <label htmlFor="vehical-loss-theft-ins-checkbox">
                                  <div className="element__checkbox">
                                    <Field
                                      type="checkbox"
                                      disabled={!this.state.vehicleLossTheftStatus}
                                      name="VEHICAL_LOSS_THEFT"
                                      id="vehical-loss-theft-ins-checkbox"
                                      onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                        if (!e.currentTarget.checked) {
                                          setFieldValue('VEHICAL_BRAND', '');
                                          setFieldValue('VEHICAL_MODEL', '');
                                          setFieldValue('VEHICAL_BRAND_NAME', '');
                                          setFieldValue('VEHICAL_MODEL_NAME', '');
                                          setFieldValue('REPLACEMENT_PRICE', '');
                                          commonService.setSelectOptName(setFieldValue, 'VEHICAL_BRAND_NAME', '');
                                          commonService.setSelectOptName(setFieldValue, 'VEHICAL_MODEL_NAME', '');
                                          this.setState({ activeVehicleType: '', isReplacePriceError: false });
                                        }
                                        this.handleFetchVehicleType(this.state.activeBrand, e.currentTarget.checked, values.ENGINE_DISPLACEMENT, values.ENGINE_DISPLACEMENT_UNIT, values.MANUFACTUR_YEAR_MONTH);
                                      }}
                                    />
                                    <div className="element__checkbox-btn" />
                                  </div>
                                  <span>{type === InsTypeDefinesEN[InsTypeEnum.Car] 
                                  ? '我要投保任意險(車體損失險/竊盜損失險/第三人責任險)' 
                                  : '我要投保任意險(第三人責任險)'}
                                  </span>
                                </label>
                              </div>
                            )}
                            {
                              this.props.type !== 'moto' && (
                                <p className="element__highlight-text">{commonService.getCodeMsg(this.props.UICodes, CodeId.U038)}</p>
                              )
                            }
                          </div>
                        </div>
                        <div className="element__form-table-container">
                          <div className="element__form-table-left">
                            <div className="element__form-table-tr">
                              <div className="element__form-table-td">
                                {/* 製造年月 */}
                                <div className={'element__form-group' + (errors.MANUFACTUR_YEAR_MONTH && touched.MANUFACTUR_YEAR_MONTH ? ' element__form-group--invalid' : '')}>
                                  <div className="element__form-group-title">製造年月*<span className="ant-picker-exam-info">範例： 2020/01</span></div>
                                  <DatePicker
                                    name="MANUFACTUR_YEAR_MONTH"
                                    data-fieldname="MANUFACTUR_YEAR_MONTH"
                                    tabIndex={2}
                                    className="element__input"
                                    picker="month"
                                    format="YYYY/MM"
                                    disabledDate={(current: any) => {
                                      return current && (current > moment() || current < moment('1911/01/01'));
                                    }}
                                    onChange={(val: any) => {
                                      this.handleYearMonthChange(val, setFieldValue, setFieldTouched);
                                      setFieldValue('MANUFACTUR_YEAR_MONTH', val);
                                    }}
                                  />
                                  <div className="element__error-message">
                                    <ErrorMessage name="MANUFACTUR_YEAR_MONTH" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-tr">
                              <div className="element__form-table-td">
                                {/* 原始發照日期 */}
                                <div className={'element__form-group' + (
                                  (errors.ORIGINAL_DATE_YEAR && touched.ORIGINAL_DATE_YEAR) ||
                                    (errors.ORIGINAL_DATE_MONTH && touched.ORIGINAL_DATE_MONTH) ||
                                    (errors.ORIGINAL_DATE_DATE && touched.ORIGINAL_DATE_DATE) ? ' element__form-group--invalid' : '')}
                                >
                                  <div className="element__form-group-title">原始發照日期*</div>
                                  <div className="element__form-group-content">
                                    <Field
                                      as="select"
                                      id="original-date-year-select"
                                      className="element__select"
                                      name="ORIGINAL_DATE_YEAR"
                                      data-fieldname="ORIGINAL_DATE_YEAR"
                                      tabIndex={3}
                                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        // this.handleOriginalYearChange(e.currentTarget.value, values.MANUFACTUR_YEAR_MONTH, setFieldValue);
                                        handleChange('ORIGINAL_DATE_YEAR')(e);
                                      }}
                                    >
                                      <option value="">請選擇</option>
                                      {
                                        this.handleCreateYearOpt(values.MANUFACTUR_YEAR_MONTH)
                                      }
                                    </Field>
                                    <Field
                                      as="select"
                                      id="original-date-month-select"
                                      className="element__select"
                                      name="ORIGINAL_DATE_MONTH"
                                      data-fieldname="ORIGINAL_DATE_MONTH"
                                      tabIndex={4}
                                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        // this.handleOriginalMonthChange(values.ORIGINAL_DATE_YEAR, e.currentTarget.value, values.MANUFACTUR_YEAR_MONTH, setFieldValue);
                                        handleChange('ORIGINAL_DATE_MONTH')(e);
                                      }}
                                    >
                                      <option value="">請選擇</option>
                                      {
                                        this.handleCreateOriginalMonthOpts(values.MANUFACTUR_YEAR_MONTH, values.ORIGINAL_DATE_YEAR)
                                      }
                                    </Field>
                                    <Field
                                      as="select"
                                      id="original-date-day-select"
                                      className="element__select"
                                      name="ORIGINAL_DATE_DATE"
                                      data-fieldname="ORIGINAL_DATE_DATE"
                                      tabIndex={5}
                                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                        handleChange('ORIGINAL_DATE_DATE')(e);
                                      }}
                                    >
                                      <option value="">請選擇</option>
                                      {
                                        this.handleCreateOriginalDateOpts(values.MANUFACTUR_YEAR_MONTH, values.ORIGINAL_DATE_YEAR, values.ORIGINAL_DATE_MONTH)
                                      }
                                    </Field>
                                  </div>
                                  <div className="element__error-message">
                                    {
                                      errors.ORIGINAL_DATE_YEAR
                                        ? <ErrorMessage name="ORIGINAL_DATE_YEAR" />
                                        : errors.ORIGINAL_DATE_MONTH
                                          ? <ErrorMessage name="ORIGINAL_DATE_MONTH" />
                                          : errors.ORIGINAL_DATE_DATE
                                            ? <ErrorMessage name="ORIGINAL_DATE_DATE" />
                                            : ''
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-tr displacement">
                              <div className="element__form-table-td">
                                {/* 排氣量或馬力 */}
                                <div className={'element__form-group' + (errors.ENGINE_DISPLACEMENT && touched.ENGINE_DISPLACEMENT ? ' element__form-group--invalid' : '')}>
                                  <div className="element__form-group-title">排氣量或馬力*</div>
                                  <div className="element__form-group-content">
                                    <Field
                                      component={InputWithRegex}
                                      regex={/^[\d]{0,4}(\.[\d]{0,2})?$/}
                                      name="ENGINE_DISPLACEMENT"
                                      data-fieldname="ENGINE_DISPLACEMENT"
                                      tabIndex={6}
                                      className="element__input"
                                      maxLength="7"
                                      autoComplete="off"
                                      validate={this.validateEngineDisplacementField}
                                      onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setFieldTouched('ENGINE_DISPLACEMENT', true);
                                        this.handleFetchVehicleType(this.state.activeBrand, values.VEHICAL_LOSS_THEFT, e.currentTarget.value, values.ENGINE_DISPLACEMENT_UNIT, values.MANUFACTUR_YEAR_MONTH);
                                      }}
                                    />
                                    <div className="radio-group-container">{vehiclePower}</div>
                                  </div>
                                  <div className="element__error-message">
                                    <ErrorMessage name="ENGINE_DISPLACEMENT" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {(type === InsTypeDefinesEN[InsTypeEnum.Car] || type === InsTypeDefinesEN[InsTypeEnum.Moto]) && values.VEHICAL_LOSS_THEFT && (
                              <>
                                <div className="element__form-table-tr">
                                  <div className="element__form-table-td">
                                    {/* 車款 */}
                                    <div className={'element__form-group' + (errors.VEHICAL_BRAND && touched.VEHICAL_BRAND ? ' element__form-group--invalid' : '')}>
                                      <div className="element__form-group-title">車款*</div>
                                      <Field
                                        as="select"
                                        name="VEHICAL_BRAND"
                                        data-fieldname="VEHICAL_BRAND"
                                        tabIndex={7}
                                        className="element__select"
                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                          handleChange(e);
                                          setFieldValue('VEHICAL_MODEL', '');
                                          setFieldValue('VEHICAL_MODEL_NAME', '');
                                          setFieldValue('REPLACEMENT_PRICE', '');
                                          // setFieldValue('LIMIT', '');
                                          this.setState({ activeVehicleType: e.currentTarget.value });
                                          commonService.setSelectOptName(setFieldValue, 'VEHICAL_BRAND_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                        }}
                                        disabled={this.state.vehicleType.VEHICLE_LIST.length === 1}
                                      >
                                        <option value="">請選擇</option>
                                        {vehicleTypeList}
                                      </Field>
                                      <div className="element__error-message">
                                        <ErrorMessage name="VEHICAL_BRAND" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="element__form-table-tr">
                                  <div className="element__form-table-td">
                                    {/* 車型 */}
                                    <div className={'element__form-group' + (errors.VEHICAL_MODEL && touched.VEHICAL_MODEL ? ' element__form-group--invalid' : '')}>
                                      <div className="element__form-group-title">車型*</div>
                                      <div className={'vehical-info__vehicle-models-select' + (values.VEHICAL_BRAND ? '' : ' vehical-info__vehicle-models-select--disabled')}>
                                        <div className="element__select" onClick={() => values.VEHICAL_BRAND ? this.props.setSelectVehicleModelsModalVisible(true) : false}>
                                          <span>{values.VEHICAL_MODEL_NAME ? values.VEHICAL_MODEL_NAME : '請選擇'}</span>
                                        </div>
                                        <Field type="hidden" name="VEHICAL_MODEL" />
                                      </div>
                                      {/*
                                        <Field
                                          as="select"
                                          name="VEHICAL_MODEL"
                                          data-fieldname="VEHICAL_MODEL"
                                          tabIndex={8}
                                          className="element__select"
                                          onChange={(e:React.ChangeEvent<HTMLSelectElement>) => {
                                            handleChange(e);
                                            this.handleFetchReplacePrice(e.currentTarget.value, setFieldValue);
                                            this.handleFetchLIMIT(e.currentTarget.value, setFieldValue);
                                            commonService.setSelectOptName(setFieldValue, 'VEHICAL_MODEL_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                          }}
                                        >
                                          <option value="">請選擇</option>
                                          {vehicleTypeModels}
                                        </Field>
                                        */}
                                      <div className="element__error-message">
                                        <ErrorMessage name="VEHICAL_MODEL" />
                                      </div>
                                    </div>
                                    {/* 選擇車型 (Modal) */}
                                    <SelectVehicleModelsModal
                                      vehicleModels={vehicleModels}
                                      activeVehicleModel={values.VEHICAL_MODEL}
                                      formikFieldNameVehicleModel="VEHICAL_MODEL"
                                      formikFieldNameVehicleModelName="VEHICAL_MODEL_NAME"
                                      formikSetFieldValue={setFieldValue}
                                      formikSetFieldTouched={setFieldTouched}
                                      onSetVehicleInfo={this.handleSetVehicleInfo}
                                      onFetchLIMIT={this.handleFetchLIMIT}
                                      handleVehiclePowerOptionToggle={this.selectVehicleModelChangePowerOption}
                                      prowerUnit={this.state.isEcarPlate ? 'HP' : 'C.C'}
                                    />
                                  </div>
                                </div>
                                <div className="element__form-table-tr">
                                  <div className="element__form-table-td">
                                    {/* 重置價格 */}
                                    <div className={'element__form-group' + (errors.REPLACEMENT_PRICE && touched.REPLACEMENT_PRICE ? ' element__form-group--invalid' : '')}>
                                      <div className="element__form-group-title">重置價格*</div>
                                      <Field
                                        component={InputWithRegex}
                                        name="REPLACEMENT_PRICE"
                                        data-fieldname="REPLACEMENT_PRICE"
                                        tabIndex={9}
                                        className="element__input"
                                        autoComplete="off"
                                        maxLength={8}
                                        disabled={this.state.disabledReplacementPrice}
                                        onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                          handleBlur(e);
                                          setFieldTouched('REPLACEMENT_PRICE', true);
                                          this.handleReplacePriceChange(e.currentTarget.value);
                                        }}
                                      />
                                      <div className="element__error-message">
                                        <ErrorMessage name="REPLACEMENT_PRICE" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="element__form-table-tr limit">
                              <div className="element__form-table-td">
                                {/* 乘載限制 */}
                                <div className={'element__form-group' + (errors.LIMIT && touched.LIMIT ? ' element__form-group--invalid' : '')}>
                                  <div className="element__form-group-title">乘載限制*</div>
                                  <div className="element__form-group-content">
                                    <Field
                                      component={InputWithRegex}
                                      name="LIMIT"
                                      data-fieldname="LIMIT"
                                      tabIndex={10}
                                      disabled={this.props.insTypeId === InsType.Moto || (this.props.insTypeId === InsType.Car && this.state.vehicleType.VEHICLE_LIST.length > 0 && this.state.activeVehicleModel && Number(this.state.activeVehicleModel.QPT) > 0)}
                                      className="element__input"
                                      autoComplete="off"
                                      maxLength={this.props.insTypeId === InsType.Car ? 2 : 1}
                                      onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        setFieldTouched('LIMIT', true);
                                      }}
                                      placeholder="請依行照填入乘載人數"
                                    />
                                  </div>
                                  <div className="element__error-message">
                                    <ErrorMessage name="LIMIT" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-right">
                            <VehicleReg>
                              {this.props.insTypeId === InsType.Car &&
                                <VehicleReg.CarReg
                                  infoData={this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue}
                                  vehicleData={values}
                                />}
                              {this.props.insTypeId === InsType.Moto &&
                                <VehicleReg.MotoReg
                                  infoData={this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue}
                                  vehicleData={values}
                                />}
                            </VehicleReg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="insure-process-vehical-info__controls">
                <button type="button" className="element__button element__button--red-border" onClick={() => this.handleGoBack(values)}>返回上一頁</button>
                <button type="submit" className="element__button element__button--red" disabled={this.state.isReplacePriceError}>下一步</button>
              </div>
              <FormikFocusError />
            </Form>
          )}
        </Formik>
        {/* 如何填寫 (Modal) */}
        <FillExampleModal />
        {/* 選擇廠牌 (Modal) */}
        <SelectVehicleBrandsModal />
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => ({
  selectItem: state.modal.selectVehicleBrandsModalState.selectItem,
  fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFillExampleModalVisible: (visible: boolean) => dispatch(setFillExampleModalVisibleAction(visible)),
  setSelectVehicleBrandsModalVisible: (visible: boolean, vehicleBrands?: VehicleBrand[]) => dispatch(setSelectVehicleBrandsModalVisibleAction(visible, vehicleBrands)),
  setSelectVehicleModelsModalVisible: (visible: boolean) => dispatch(setSelectVehicleModelsModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(InsureProcessVehicalInfo);
